"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeReverser = void 0;
const Vector2D_js_1 = __importDefault(require("jsts/org/locationtech/jts/math/Vector2D.js"));
const pipeCommonUtil_1 = require("../util/pipeCommonUtil");
const pipeNode_1 = require("../pipeNode");
class NodeReverser {
    executeForWarehouse(handleNodes, referencedMainPipes) {
        for (let i = 0; i < handleNodes.length; i++) {
            let mainNode = handleNodes[i];
            if (this.isSinglePath(mainNode) === false) { //判断需要翻转的点组是否有多条路径，有多条路径则跳过
                continue;
            }
            let minDis_mainPipe = Number.POSITIVE_INFINITY;
            let closestMainPipe;
            //与最近的主管线的关系分两种情况
            //一种是平行，按走向来判断是否翻转
            //一种是垂直，按距离来判断是否翻转
            for (let mainPipe of referencedMainPipes) {
                let point = mainPipe.closestPoint(mainNode._point);
                let dis = point.distance(mainNode._point);
                if (dis < minDis_mainPipe) {
                    minDis_mainPipe = dis;
                    closestMainPipe = mainPipe;
                }
            }
            //异常情况，跳过
            if (closestMainPipe === undefined) {
                continue;
            }
            let mainPipeVec = new Vector2D_js_1.default(closestMainPipe.p0, closestMainPipe.p1);
            let secondMainNode;
            for (let child of mainNode._children) {
                if (child._type == pipeNode_1.PipeNodeType.Main) {
                    secondMainNode = child;
                    break;
                }
            }
            if (secondMainNode === undefined) { //只有一个主节点的情况，不需要处理
                continue;
            }
            let groupVec = new Vector2D_js_1.default(mainNode._point, secondMainNode._point);
            let angle = Math.abs(mainPipeVec.angleTo(groupVec));
            //两个向量偏向于平行
            if (this.isTendToParallel(mainPipeVec, groupVec)) {
                //大于90°则说明是反向的，进行反转
                //更靠近p1点且反向的时候，才进行反转
                if (angle > Math.PI / 2 && mainNode._point.distance(closestMainPipe.p0) > mainNode._point.distance(closestMainPipe.p1)) {
                    handleNodes[i] = this.reverseNodes(mainNode);
                }
            }
            else { //偏向于垂直
                //若第一个主节点距离主管线更远，则需要反转
                if (closestMainPipe.distance(mainNode._point) > closestMainPipe.distance(secondMainNode._point)) {
                    handleNodes[i] = this.reverseNodes(mainNode);
                }
            }
        }
    }
    isTendToParallel(vec1, vec2) {
        let angle = Math.abs(vec1.angleTo(vec2)) * 180 / Math.PI; //范围为0~180°
        return 180 - angle < 45 || angle < 45;
    }
    executeForNormalRoom(startNode) {
        let mainNodes = new Array();
        pipeCommonUtil_1.PipeCommonUtil.traverseToGetMainPipeNodes(startNode, mainNodes);
        if (this.isSinglePath(startNode) === false) { //判断需要翻转的点组是否有多条路径，有多条路径则跳过
            return null;
        }
        return this.reverseNodes(startNode);
    }
    //判断需要翻转的点组是否有多条路径
    isSinglePath(startNode) {
        let currentNode = startNode;
        while (true) {
            let mainNodeNumOfChildren = 0;
            let childMainNode;
            for (let child of currentNode._children) {
                if (child._type == pipeNode_1.PipeNodeType.Main) {
                    mainNodeNumOfChildren++;
                    childMainNode = child;
                }
            }
            if (mainNodeNumOfChildren > 1)
                return false;
            else if (mainNodeNumOfChildren == 0)
                break;
            currentNode = childMainNode;
        }
        return true;
    }
    reverseNodes(startNode) {
        let mainNodes = [startNode];
        let currentNode = startNode;
        while (true) {
            let end = true;
            for (let child of currentNode._children) {
                if (child._type == pipeNode_1.PipeNodeType.Main) {
                    mainNodes.push(child);
                    currentNode = child;
                    end = false;
                    break;
                }
            }
            if (end)
                break;
        }
        //移除原有的父子关系
        for (let i = 0; i < mainNodes.length - 1; i++) {
            mainNodes[i].removeChildNode(mainNodes[i + 1]);
        }
        //重建父子关系
        for (let i = mainNodes.length - 1; i > 0; i--) {
            mainNodes[i].addChildNode(mainNodes[i - 1]);
        }
        return mainNodes[mainNodes.length - 1];
    }
}
exports.NodeReverser = NodeReverser;
